import { render, staticRenderFns } from "./TaskItemDeadline.vue?vue&type=template&id=17c4bcae&"
import script from "./TaskItemDeadline.vue?vue&type=script&lang=js&"
export * from "./TaskItemDeadline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports